import {
    FORM_LABEL_TEXT,
    FORM_FIELDS_LABEL_TEXT,
    BUTTON_LABEL_TEXT,
    TICKET_EMAIL_LABEL,
    HEADLINE_LABEL,
    ERRORS_LABEL,
    TEXT_ELEMENT_LABEL,
    STANDALONE_TICKET_LABEL,
    STANDALONE_TICKET_SUB_LABEL_DEFAULT,
    ADD_ON_TICKET_LABEL,
    ADD_ON_TICKET_SUB_LABEL_DEFAULT,
    NESTED_TICKET_LABEL,
    NESTED_TICKET_SUB_LABEL_DEFAULT,
    TICKET_LABEL,
    NAME_LABEL,
    DESCRIPTION_LABEL,
    PRICE_LABEL,
    QUANTITY_LABEL,
    REMAINING_LABEL,
    DATE_TIME_LABEL,
    SOLD_OUT_LABEL,
    HEADLINES_LABEL,
    PRIMARY_BUTTON_LABEL_TEXT,
    SECONDARY_BUTTON_LABEL_TEXT,
    STEPPER_LABEL,
    SESSION_DETAILS_LABEL,
} from './formStyleLabels';

export const FORM = 'form';
export const FORM_FIELDS = 'formFields';
export const BUTTON = 'button';
export const HEADLINE = 'headline';
export const ERRORS = 'errors';
export const TEXT_ELEMENT = 'textElement';
export const TICKET_EMAIL = 'ticketEmail';
export const STANDALONE_TICKET = 'standalone';
export const ADD_ON_TICKET = 'addOn';
export const NESTED_TICKET = 'nested';
export const TICKET = 'ticket';
export const NAME = 'name';
export const DESCRIPTION = 'description';
export const PRICE = 'price';
export const QUANTITY = 'quantity';
export const REMAINING = 'remaining';
export const DATE_TIME = 'dateTime';
export const SOLD_OUT = 'soldOut';
export const PRIMARY_BUTTON = 'primary button';
export const SECONDARY_BUTTON = 'secondary button';
export const HEADLINES = 'headlines';
export const STEPPER = 'stepper';
export const SESSION_DETAILS = 'session details';

/** @var {Array} - ordered list of identifiers. */
export const formPanels = [FORM, HEADLINE, FORM_FIELDS, TEXT_ELEMENT, TICKET_EMAIL, BUTTON, ERRORS];
export const formSessionPanels = [
    FORM,
    STEPPER,
    HEADLINES,
    FORM_FIELDS,
    SESSION_DETAILS,
    TEXT_ELEMENT,
    PRIMARY_BUTTON,
    SECONDARY_BUTTON,
    ERRORS,
];

export const ticketPanels = [STANDALONE_TICKET, ADD_ON_TICKET, NESTED_TICKET];

export const ticketEditorPanels = [TICKET, NAME, DESCRIPTION, PRICE, QUANTITY, REMAINING, DATE_TIME, SOLD_OUT];

export const styleEditorPanels = [...formPanels, ...ticketPanels, ...ticketEditorPanels];

/** @var {Object} - headline labels by collapsible identifier. */
export const collapsibleLabels = {
    [FORM]: FORM_LABEL_TEXT,
    [HEADLINE]: HEADLINE_LABEL,
    [FORM_FIELDS]: FORM_FIELDS_LABEL_TEXT,
    [TEXT_ELEMENT]: TEXT_ELEMENT_LABEL,
    [BUTTON]: BUTTON_LABEL_TEXT,
    [TICKET_EMAIL]: TICKET_EMAIL_LABEL,
    [ERRORS]: ERRORS_LABEL,
    [STANDALONE_TICKET]: STANDALONE_TICKET_LABEL,
    [ADD_ON_TICKET]: ADD_ON_TICKET_LABEL,
    [NESTED_TICKET]: NESTED_TICKET_LABEL,
    [TICKET]: TICKET_LABEL,
    [NAME]: NAME_LABEL,
    [DESCRIPTION]: DESCRIPTION_LABEL,
    [PRICE]: PRICE_LABEL,
    [QUANTITY]: QUANTITY_LABEL,
    [REMAINING]: REMAINING_LABEL,
    [DATE_TIME]: DATE_TIME_LABEL,
    [SOLD_OUT]: SOLD_OUT_LABEL,
    [STEPPER]: STEPPER_LABEL,
    [HEADLINES]: HEADLINES_LABEL,
    [PRIMARY_BUTTON]: PRIMARY_BUTTON_LABEL_TEXT,
    [SECONDARY_BUTTON]: SECONDARY_BUTTON_LABEL_TEXT,
    [SESSION_DETAILS]: SESSION_DETAILS_LABEL,
};

/** @var {Object} - headline labels by collapsible identifier. */
export const collapsibleSubLabels = {
    [STANDALONE_TICKET]: STANDALONE_TICKET_SUB_LABEL_DEFAULT,
    [ADD_ON_TICKET]: ADD_ON_TICKET_SUB_LABEL_DEFAULT,
    [NESTED_TICKET]: NESTED_TICKET_SUB_LABEL_DEFAULT,
};
